/**
 * AmbassadorTraining — Training Academy for Peace of Sleep ambassadors
 *
 * Single-page app that navigates between course list, course view,
 * module viewer, and assessment viewer using local state.
 * Uses shared viewer components with Peace of Sleep gold accent.
 */

import { useState } from 'react';
import { CourseList, CourseView, ModuleView, AssessmentView } from '../../components/training/viewer';
import { POS_GOLD } from '../../config/posRoomStatus';


type View =
  | { screen: 'courses' }
  | { screen: 'course'; courseId: string }
  | { screen: 'module'; moduleId: string; courseId?: string }
  | { screen: 'assessment'; assessmentId: string; courseId?: string };

function AmbassadorTraining() {
  const [view, setView] = useState<View>({ screen: 'courses' });

  switch (view.screen) {
    case 'courses':
      return (
        <CourseList
          onSelectCourse={(courseId) => setView({ screen: 'course', courseId })}
          accentColor={POS_GOLD}
        />
      );

    case 'course':
      return (
        <CourseView
          courseId={view.courseId}
          onSelectModule={(moduleId) => setView({ screen: 'module', moduleId, courseId: view.courseId })}
          onSelectAssessment={(assessmentId) => setView({ screen: 'assessment', assessmentId, courseId: view.courseId })}
          onBack={() => setView({ screen: 'courses' })}
          accentColor={POS_GOLD}
        />
      );

    case 'module':
      return (
        <ModuleView
          moduleId={view.moduleId}
          onBack={() => view.courseId
            ? setView({ screen: 'course', courseId: view.courseId })
            : setView({ screen: 'courses' })
          }
          accentColor={POS_GOLD}
        />
      );

    case 'assessment':
      return (
        <AssessmentView
          assessmentId={view.assessmentId}
          onBack={() => view.courseId
            ? setView({ screen: 'course', courseId: view.courseId })
            : setView({ screen: 'courses' })
          }
          accentColor={POS_GOLD}
        />
      );
  }
}

export default AmbassadorTraining;
